"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var shared_1 = require("@formily/shared");
var FormSpy_1 = require("./FormSpy");
var core_1 = require("@formily/core");
var transformStatus = function (type, ref) {
    switch (type) {
        case core_1.LifeCycleTypes.ON_FORM_INIT:
            return 'initialize';
        case core_1.LifeCycleTypes.ON_FORM_SUBMIT_START:
            ref.current.submitting = true;
            return 'submitting';
        case core_1.LifeCycleTypes.ON_FORM_SUBMIT_END:
            ref.current.submitting = false;
            return 'submitted';
        default:
            return ref.current.submitting ? 'submitting' : type;
    }
};
var transformFormAPI = function (api, type, ref) {
    shared_1.deprecate('FormConsumer', 'Please use FormSpy Component.');
    return {
        status: transformStatus(type, ref),
        state: api.getFormState(),
        submit: api.submit,
        reset: api.reset
    };
};
exports.FormConsumer = function (props) {
    var ref = react_1.useRef({});
    return (react_1.default.createElement(FormSpy_1.FormSpy, __assign({}, props), function (_a) {
        var form = _a.form, type = _a.type;
        if (!form)
            return react_1.default.createElement(react_1.default.Fragment, null);
        return shared_1.isFn(props.children)
            ? props.children(transformFormAPI(form, type, ref))
            : props.children;
    }));
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@formily/react/lib/components/FormConsumer.js
// module id = 4652
// module chunks = 0